import { CheckCircle, HourglassEmpty } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { GqlPlannerV2VisitSimplifiedStatus } from "~/__generated__";

type Props = {
    visitStatus: GqlPlannerV2VisitSimplifiedStatus;
};

const STATUS_META: Record<
    GqlPlannerV2VisitSimplifiedStatus,
    {
        icon: JSX.Element;
        color: "secondary" | "success" | "warning";
        labelKey: string;
        defaultLabel: string;
    }
> = {
    [GqlPlannerV2VisitSimplifiedStatus.Unplanned]: {
        icon: <HourglassEmpty fontSize="small" />,
        color: "secondary",
        labelKey: "VisitSimplifiedStatusChip.unplanned",
        defaultLabel: "Unplanned",
    },
    [GqlPlannerV2VisitSimplifiedStatus.Planned]: {
        icon: <HourglassEmpty fontSize="small" />,
        color: "secondary",
        labelKey: "VisitSimplifiedStatusChip.planned",
        defaultLabel: "Planned",
    },
    [GqlPlannerV2VisitSimplifiedStatus.EcoTeamReview]: {
        icon: <HourglassEmpty fontSize="small" />,
        color: "warning",
        labelKey: "VisitSimplifiedStatusChip.ecoTeamReview",
        defaultLabel: "Eco Team Review",
    },
    [GqlPlannerV2VisitSimplifiedStatus.Approved]: {
        icon: <CheckCircle fontSize="small" />,
        color: "success",
        labelKey: "VisitSimplifiedStatusChip.approved",
        defaultLabel: "Approved",
    },
};

export default function VisitSimplifiedStatusChip({ visitStatus: status }: Props) {
    const { t } = useTranslation("shared");
    const current = STATUS_META[status];

    return (
        <Chip
            label={
                <span
                    style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "block",
                        maxWidth: "100%",
                    }}
                >
                    {t(current.labelKey, current.defaultLabel)}
                </span>
            }
            icon={current.icon}
            color={current.color}
            size="small"
            sx={{
                maxWidth: "100%",
                flexShrink: 1,
            }}
        />
    );
}
